<script setup lang="ts">
import { ref } from "vue";

export interface Option {
  label: string;
  value: number;
}

const props = withDefaults(
  defineProps<{
    options?: Option[];
    initialPageSize?: Option;
  }>(),
  {
    options: () => [
      { label: "10", value: 10 },
      { label: "25", value: 25 },
      { label: "50", value: 50 },
      { label: "100", value: 100 },
    ],
    initialPageSize: () => ({ label: "10", value: 10 }),
  },
);

const currentPageSize = ref<number>(props.initialPageSize.value);

const emit = defineEmits<{
  change: [pageSize: number];
}>();

function handleChange(event: Event) {
  const target = event.target as HTMLSelectElement;
  currentPageSize.value = Number(target.value);
  emit("change", Number(target.value));
}
</script>

<template>
  <div class="flex items-center gap-1">
    <label class="font-medium text-[#555]">
      {{ $t("common.table.pagination.show") }}:
    </label>
    <select
      :value="currentPageSize"
      @change="handleChange"
      class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer"
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    <label class="font-medium text-[#555]">
      {{ $t("common.table.pagination.records") }}
    </label>
  </div>
</template>
